// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"935":"effdfdc3","2190":"85f05151","3501":"f81c71a6","9809":"85f05151"}[chunkId] + ".chunk.css";
};